import i18n from '@/plugins/i18n'
import { PRIVATE_LAYOUT } from '@/constants/layouts'
import { PROFESSIONAL_ROLE } from '@/constants/roles'
import routeHelpers from '@/router/routeHelpers'

let routes = [
  {
    path: 'es-nodofarma',
    name: 'EsNodofarma',
    component: () => import('@/components/webapp/professional/EsNodofarma'),
    meta: {
      pageTitle: 'Nuevo tratamiento'
    }
  },
  {
    path: 'es-nodofarma-list',
    name: 'PrescriptionList',
    component: () => import('@/components/webapp/professional/PrescriptionList'),
    meta: {
      pageTitle: 'Lista tratamientos'
    }
  },
  {
    path: 'professional-network',
    name: 'Search',
    component: () => import('@/components/webapp/patient/search/Search'),
    meta: {
      showTabMenu: true,
      bequeath: true,
			title: {
				text () {
					return i18n.t('searcherTitle')
				},
				hide: true
			},
			i18n: ['public/views/patient/search', 'public/views/shared/chat']
    }
  },
  {
    path: 'chats/:appointmentId?',
    name: 'ProfessionalChat',
    component: () => import('@/components/views/chat-interconsultations/Chat'),
		props: true,
    meta: {
      showTabMenu: true,
      i18n: ['public/views/shared/chat', 'public/views/patient/appointments', 'public/views/patient/search'],
      title: {
        text () {
          return i18n.t('chats.chat')
        },
        hide: true
      }
    }
  }
]

export default routeHelpers.completeRoutesMeta(routes, PROFESSIONAL_ROLE, PRIVATE_LAYOUT)



// WEBPACK FOOTER //
// ./src/router/routes/webapp/professional.routes.js